import styled from 'styled-components';

import IconButton from '../IconButton';

const ButtonAction = styled(IconButton)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  padding: 0;
  background-color: #d8d8d8;
  border-radius: 100%;
  cursor: pointer;
  transition: background-color 0.2s linear;
  svg {
    width: 10px;
    height: 10px;
  }
`;

export default ButtonAction;
